module.exports = __webpack_public_path__ + "static/media/blink-two.20530333.svg";